import { Outlet, createFileRoute } from '@tanstack/react-router';
import { Suspense } from 'react';

import { HStack, VStack } from '@/components/Layout';
import { Skeleton } from '@/components/ui/skeleton';

import { ProductionDetailHeader } from './-components/ProductionDetailHeader';

export const Route = createFileRoute(
  '/_stacktrace/production/$productionId/_layout',
)({
  component: Layout,
});

function ProductionDetailHeaderSkeleton() {
  return (
    <VStack className="gap-4 bg-neutral-fill px-12 pt-4 shadow-xs">
      <HStack className="items-start justify-between gap-6">
        <HStack className="items-start gap-4 grow">
          <Skeleton className="size-12 shrink-0" />
          <VStack className="grow gap-2">
            <Skeleton className="h-6 w-32 rounded-full" />
            <Skeleton className="h-8 w-72" />
            <Skeleton className="h-5 w-48" />
          </VStack>
        </HStack>
      </HStack>
    </VStack>
  );
}

function Layout() {
  return (
    <VStack>
      <Suspense fallback={<ProductionDetailHeaderSkeleton />}>
        <ProductionDetailHeader />
      </Suspense>
      <Suspense fallback={<div className="flex-1 px-12 py-5" />}>
        <Outlet />
      </Suspense>
    </VStack>
  );
}
